import { Injectable } from '@angular/core';

import { WindowService } from './window.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ApiService {
  private api_url: any;
  private api_cus: any;
  private formdata = new FormData();
  lang:string;
  
  

  constructor(private win: WindowService, private http: HttpClient) {
    this.api_url = (this.win.nativeWindow.api_setting) ? this.win.nativeWindow.api_settings.root + 'wp/v2/' : 'http://edelgrundwp:81/wp-json/wp/v2/';
    this.api_cus = location.origin + '/wp-admin/admin-ajax.php';
  }
  /**
   * get home page data
   */
  getHome() {
    this.formdata.append('action', 'home');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get home page data
   */
  getContactPage() {
    this.formdata.append('action', 'contact_page');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get home page data
   */
  getPage404() {
    this.formdata.append('action', 'page_404');
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get about page data
   */
  getAbout() {
    this.formdata.append('action', 'about');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get philosophy page data
   */
  getPhilosophy() {
    this.formdata.append('action', 'philosophy');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get quality page data
  */
  getQuality() {
    this.formdata.append('action', 'quality');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get Fair Trade page data
  */
  getFairTrade() {
    this.formdata.append('action', 'fairtrade');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }
  /**
   * get custom order page
  */
  getCustomOrderPage() {
    this.formdata.append('action', 'custom_order');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }
  /**
   * get Designers page data
  */
  getDesignersPage(){
    this.formdata.append('action', 'designers_page');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }
  /**
   * get Designers data
  */
  getDesigners(){
    this.formdata.append('action', 'designers');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get designer
   * @param slug page
  */
  getDesigner(slug){
    this.formdata.append('action', 'designer');
    this.formdata.append('slug', slug);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
     * get Fair Trade page data
  */
  getCollectionsPage() {
    this.formdata.append('action', 'collections_page');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get collections
  */
  getCollections(){
    this.formdata.append('action', 'collections');
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get collections
  */
  getCollectionTerm(slug){
    this.formdata.append('action', 'collection_term');
    this.formdata.append('slug', slug);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get blog page
  */
  getBlogPage(){
    this.formdata.append('action', 'blog');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get blog terms
  */
  getBlogTerms(){
    this.formdata.append('action', 'blog_term');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get blog posts
  */
  getBlogPosts(term = 'false'){
    this.formdata.append('action', 'blog_posts');
    this.formdata.append('term', term);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get press page
  */
  getPressPage(){
    this.formdata.append('action', 'press');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get press terms
  */
  getPressTerms(){
    this.formdata.append('action', 'press_term');
    this.formdata.append('lang', this.lang);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get press posts
  */
  getPressPosts(term){
    this.formdata.append('action', 'press_posts');
    this.formdata.append('term', term);
    return this.http.post(this.api_cus, this.formdata);
  }

  /**
   * get post (Press/Blog)
  */
 getPost(slug:string){
  this.formdata.append('action', 'post');
  this.formdata.append('slug', slug);
  return this.http.post(this.api_cus, this.formdata);
}

/**
   * get post (Press/Blog)
  */
 subscribeUser(message:any){
  this.formdata.append('action', 'add_subscribe');
  this.formdata.append('email', message.email);
  this.formdata.append('name', message.name);
  return this.http.post(this.api_cus, this.formdata);
}

  /**
   * get storages
  */
 getStorage(term_id:string){
  this.formdata.append('action', 'load_storage');
  this.formdata.append('term_id', term_id);
  return this.http.post(this.api_cus, this.formdata);
}

/**
   * get storages
*/
getThemeSettings(){
  this.formdata.append('action', 'theme_settings');
  return this.http.post(this.api_cus, this.formdata);
}

/**
   * main image pages
*/
mainImagePages(){
  this.formdata.append('action', 'lazy_image');
  return this.http.post(this.api_cus, this.formdata);
}

/**
 * send message contact form
*/
 sendMessage(message:any){
  this.formdata.append('action', 'send_message');
  this.formdata.append('name', message.name);
  this.formdata.append('phone', message.phone);
  this.formdata.append('email', message.email);
  return this.http.post(this.api_cus, this.formdata);
}

}



// WEBPACK FOOTER //
// ./src/app/api.service.ts